export default "__VITE_ASSET__B9PhzYz9__"